import React, { FC } from "react";
import { BRAND_COLOR } from "@kivunova/kivufrontendcommon";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import PreviewIcon from "@mui/icons-material/Preview";

interface RenderRegistrationIconProps {
  index: number;
  activeStep: number;
}

const RenderRegistrationIcon: FC<RenderRegistrationIconProps> = ({
  index,
  activeStep
}) => {
  const color = index <= activeStep ? BRAND_COLOR : "#ccc";

  switch (index) {
    case 0:
      return <PersonIcon sx={{ color }} />;
    case 1:
      return <BusinessIcon sx={{ color }} />;
    case 2:
      return <PreviewIcon sx={{ color }} />;
    default:
      return <PersonIcon sx={{ color }} />;
  }
};

export default RenderRegistrationIcon;
